import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Cookies from 'js-cookie';

export default function Landing() {
  const { t } = useTranslation();
 
  return (
    <Box sx={{width:'100%', height: '99%', position: 'absolute', marginTop: 17}}>
      <p>{Cookies.get('simpalsid.auth') ? t('landing_info_ok') : t('landing_info')}</p>
    </Box>
    
  )
}
